import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

import {getHealthCard} from '../../services/getHealthCard';
import {UseGetHealthCardQueryProps} from './types';

export const useGetHealthCardQuery = ({enabled = true}: UseGetHealthCardQueryProps = {}) => {
	return useQuery({
		queryKey: [QUERY_KEYS.HEALTH_CARD],
		queryFn: async ({signal}) => getHealthCard({signal}),
		retry: 2,
		enabled,
	});
};
